export default __webpack_public_path__ + "674e54331e09d6b64658a537027a22bc.svg";